import { getCDNImageUrl } from '@/helpers/cdn';
import type { IConfig } from '../CrownMarch25/helpers';

export const getFlagsByName = (name: string) => {
  const lower = name.toLowerCase();

  return {
    fixedscroll: lower.includes('-fixedscroll'),
  };
};

export const config: IConfig = {
  'hotice-fixedscroll': {
    translation: 'welcomeSeptemberLP',
    validate: '31.10.2025',
  },
  default: {
    translation: 'welcomeApril2025',
    validate: '',
  },
};

type ImageSet = {
  desk: string;
  mob: string;
};

export const imgSrc = (src: string) => `/lp/welcome-april-2025/${src}.webp`;

export const WELCOME_APRIL_2025_PRELOAD_URLS = [
  getCDNImageUrl('/lp/welcome-april-2025/bg-desk.webp'),
  getCDNImageUrl(imgSrc('main-image')),
];

export const titleImageMap: Record<string, Record<string, ImageSet>> = {
  'hotice-fixedscroll': {
    en: {
      desk: imgSrc('fs-desk-en'),
      mob: imgSrc('fs-mob-en'),
    },
    de: {
      desk: imgSrc('fs-desk-de'),
      mob: imgSrc('fs-mob-de'),
    },
    fr: {
      desk: imgSrc('fs-desk-fr'),
      mob: imgSrc('fs-mob-fr'),
    },
  },
};
